import { Tag, registerSpanCtor } from "./Tag";

export class Span extends Tag {
    public getTagName(): string {
        return "span";
    }
}

registerSpanCtor(Span);
